// removed by extract-text-webpack-plugin
module.exports = {"root":"_tk1w3","cardContainer":"_38SCG"};


//////////////////
// WEBPACK FOOTER
// ./app/components/authCard/AnimatedCard/AnimatedCard.scss
// module id = 1161
// module chunks = 1